import type {
  InvitedCompanySummary,
  VerifyCompanyOutcome,
} from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/verifyCompanyOutcome.types"

export const STUB_INVITED_COMPANY_SUMMARY: InvitedCompanySummary = {
  name: "Acme Textiles Ltd.",
  street: "12 Rue de la Paix",
  city: "75002 Paris",
  country: "France",
}

let persistedVerifyCompanyOutcome: VerifyCompanyOutcome | null = null

/**
 * Temporary front-end stub while onboarding API contracts are under review.
 * Replace with generated API queries/mutations once TASK-3179 lands.
 */
export const getStubInvitedCompanySummary = (): InvitedCompanySummary =>
  STUB_INVITED_COMPANY_SUMMARY

export const getPersistedVerifyCompanyOutcome =
  (): VerifyCompanyOutcome | null => persistedVerifyCompanyOutcome

export const persistVerifyCompanyOutcome = (
  outcome: VerifyCompanyOutcome
): void => {
  persistedVerifyCompanyOutcome = outcome
}

export const resetVerifyCompanyOutcomeStub = (): void => {
  persistedVerifyCompanyOutcome = null
}
